export const calculateTooltipPosition = (targetRect, position) => {
  const { top, left, width, height } = targetRect;

  switch (position) {
    case 'top-left':
      return {
        top: top + window.scrollY - 60,
        left: left + window.scrollX
      };
    case 'top-center':
      return {
        top: top + window.scrollY - 240,
        left: left + window.scrollX + width / 2 - 125
      };
    case 'top-right':
      return {
        top: top + window.scrollY - 110,
        left: left + window.scrollX + width - 250
      };
    case 'bottom-left':
      return {
        top: top + window.scrollY + height + 8,
        left: left + window.scrollX
      };
    case 'bottom-center':
      return {
        top: top + window.scrollY + height + 8,
        left: left + window.scrollX + width / 2 - 125
      };
    case 'bottom-right':
      return {
        top: top + window.scrollY + height + 8,
        left: left + window.scrollX + width - 250
      };
    case 'center':
      return {
        top: top + window.scrollY + height / 2 - 30,
        left: left + window.scrollX + width / 2 - 125
      };
    case 'left-center':
      return {
        top: top + window.scrollY + height / 2 - 30,
        left: left + window.scrollX - 374
      };
    case 'right-center':
      return {
        top: top + window.scrollY + height / 2 - 90,
        left: left + window.scrollX + width + 16
      };
    case 'right-bottom':
      return {
        top: top + window.scrollY + height / 2 - 165,
        left: left + window.scrollX + width + 16
      };
    default:
      return {
        top: top + window.scrollY - 60,
        left: left + window.scrollX
      };
  }
};
